
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Endtoendcorporate() {



    const cardData =
    {
        keyword: 'End-to-End Corporate Mobility Solutions Pune',
        heading: 'etravo : End-to-End Corporate Mobility Solutions Pune',
        headingDescription: 'eTravo delivers End-to-End Corporate Mobility Solutions in Pune, streamlining business travel and employee transportation with a comprehensive fleet and professional service. From on-demand executive cabs and airport transfers to scheduled employee buses and long-term rentals, we cater to every mobility need of modern enterprises. Our GPS-enabled vehicles, trained chauffeurs, and real-time tracking systems ensure maximum efficiency, safety, and convenience. Whether it is daily commutes, intercity travel, or corporate event logistics, eTravo’s integrated approach makes us the go-to mobility partner for companies seeking reliable, scalable, and hassle-free transportation across Pune.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



"services": [
  {
    "name": "End-to-End Corporate Mobility Solutions Pune",
    "description": "eTravo offers comprehensive end-to-end corporate mobility solutions in Pune, covering everything from vehicle allocation to route planning and real-time tracking to ensure smooth staff travel."
  },
  {
    "name": "Complete Staff Commute Services Pune",
    "description": "Our complete staff commute services in Pune provide flexible bus and cab hire options, reliable pickups and drops, and customized schedules to fit your company’s needs seamlessly."
  },
  {
    "name": "Employee Pickup and Drop Management Pune",
    "description": "eTravo specializes in employee pickup and drop management in Pune, ensuring timely, safe, and efficient daily transportation with GPS tracking and professional drivers."
  },
  {
    "name": "Integrated Corporate Transport Pune",
    "description": "We deliver integrated corporate transport solutions in Pune, combining bus and cab rentals, route optimization, and fleet management to streamline your workforce mobility."
  },
  {
    "name": "Bus and Cab Hire for Companies Pune",
    "description": "eTravo provides reliable bus and cab hire for companies in Pune, perfect for daily commutes, business meetings, and corporate events with well-maintained AC vehicles."
  },
  {
    "name": "Customized Mobility Packages Pune",
    "description": "Get customized mobility packages in Pune with eTravo that fit your corporate size, shift timings, and budget, providing scalable and flexible transport services."
  },
  {
    "name": "Corporate Shuttle and Rental Services Pune",
    "description": "Our corporate shuttle and rental services in Pune ensure smooth and punctual employee transit, with options for rides, dedicated shuttles, and monthly rental contracts."
  },
  {
    "name": "Monthly Transport Plans Pune",
    "description": "eTravo’s monthly transport plans in Pune offer hassle-free employee commute management with fixed pricing, flexible vehicle options, and consistent service quality."
  },
  {
    "name": "Corporate Fleet Management Pune",
    "description": "Manage your corporate fleet efficiently with eTravo’s fleet management services in Pune, including vehicle tracking, driver management, and maintenance scheduling."
  },
  {
    "name": "Staff Movement Coordination Pune",
    "description": "We provide expert staff movement coordination in Pune, optimizing pickup/drop routes and schedules to minimize transit time and maximize employee satisfaction."
  },
  {
    "name": "Business Commute Optimization Pune",
    "description": "Optimize your business commute in Pune with eTravo’s technology-driven route planning and dynamic scheduling to reduce costs and improve punctuality."
  },
  {
    "name": "Reliable Mobility Solutions Pune",
    "description": "eTravo offers reliable mobility solutions in Pune, ensuring safe and comfortable daily transportation for employees with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Employee Commute Strategy Pune",
    "description": "Develop a strategic employee commute plan in Pune with eTravo, leveraging data analytics and flexible service options to meet your corporate mobility goals."
  },
  {
    "name": "End-to-End Staff Logistics Pune",
    "description": "Our end-to-end staff logistics service in Pune covers every aspect of employee transportation, from planning to execution and continuous monitoring for smooth operations."
  },
  {
    "name": "Managed Transport Services Pune",
    "description": "eTravo’s managed transport services in Pune take care of your entire corporate transport needs, providing turnkey solutions with dedicated support and advanced management tools."
  }
],
"tableData": [
  ["End-to-End Corporate Mobility Solutions Pune", "Complete Staff Commute Services Pune"],
  ["Employee Pickup and Drop Management Pune", "Integrated Corporate Transport Pune"],
  ["Bus and Cab Hire for Companies Pune", "Customized Mobility Packages Pune"],
  ["Corporate Shuttle and Rental Services Pune", "Monthly Transport Plans Pune"],
  ["Corporate Fleet Management Pune", "Staff Movement Coordination Pune"],
  ["Business Commute Optimization Pune", "Reliable Mobility Solutions Pune"],
  ["Employee Commute Strategy Pune", "End-to-End Staff Logistics Pune"],
  ["Managed Transport Services Pune", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Complete Corporate Mobility Solutions in Pune",
        "WhyChoosedescription": "eTravo offers end-to-end corporate mobility services designed to streamline employee and executive transportation across Pune’s business hubs, ensuring efficiency and reliability at every step."
    },
    {
        "WhyChooseheading": "Diverse Fleet Catering to All Corporate Needs",
        "WhyChoosedescription": "From hatchbacks and sedans to tempo travellers and large AC buses, our fleet supports varied transportation requirements—be it daily employee commutes, VIP transfers, or event logistics."
    },
    {
        "WhyChooseheading": "Seamless Integration with Business Operations",
        "WhyChoosedescription": "Our services are designed to align with your company’s operational hours, shift patterns, and specific mobility demands—reducing downtime and enhancing workforce productivity."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Expertise",
        "WhyChoosedescription": "All drivers are background-verified, professional, and well-acquainted with Pune’s traffic dynamics and key corporate zones such as Hinjewadi, Baner, and Magarpatta."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Customized Packages",
        "WhyChoosedescription": "We provide clear, upfront pricing with no hidden charges, offering flexible corporate mobility packages tailored to your business size and budget."
    },
    {
        "WhyChooseheading": "Advanced Safety and Hygiene Standards",
        "WhyChoosedescription": "Every vehicle undergoes regular sanitization and is equipped with safety essentials such as seat belts, GPS tracking, first aid kits, and fire extinguishers to guarantee secure travel."
    },
    {
        "WhyChooseheading": "Real-Time Monitoring and 24/7 Support",
        "WhyChoosedescription": "Track your fleet in real time and access round-the-clock customer support for schedule adjustments, emergency requests, and ongoing coordination with your HR and admin teams."
    },
    {
        "WhyChooseheading": "Scalable Solutions for Growing Businesses",
        "WhyChoosedescription": "Whether you’re a startup or an established enterprise, eTravo’s end-to-end corporate mobility services in Pune scale effortlessly to meet your evolving transportation needs."
    }
]



















    }

const faqData = [
    [
        {
            question: 'What does eTravo offer as part of its end-to-end corporate mobility solutions in Pune?',
            answer: 'eTravo delivers complete corporate mobility solutions in Pune, covering employee transport, executive car rentals, event logistics, intercity travel, and on-demand fleet support — all under one platform.',
        },
        {
            question: 'Can eTravo handle integrated transport for large enterprises in Pune?',
            answer: 'Yes, eTravo supports large enterprises with multi-layered mobility requirements including shift-based transport, VIP travel, and scalable solutions backed by tech-enabled monitoring and reporting.',
        },
        {
            question: 'Does eTravo offer custom mobility planning for corporate clients in Pune?',
            answer: 'Absolutely. We design tailor-made mobility plans based on your business hours, staff distribution, compliance policies, and safety needs to ensure seamless transportation.',
        },
        {
            question: 'What kind of fleet is included in eTravo’s corporate mobility offering in Pune?',
            answer: 'The fleet includes hatchbacks, sedans, premium SUVs, tempo travellers, and AC buses (13–50 seaters), all available for scheduled, on-demand, and long-term deployments.',
        },
        {
            question: 'Is there a central support system for managing corporate mobility in Pune?',
            answer: 'Yes, eTravo provides a centralized command center with a dedicated account manager, real-time tracking, issue resolution support, and regular performance analytics for total mobility management.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Vivek Kulkarni',
        designation: 'Corporate Services Head, Novatek Industries, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo handles our entire corporate mobility in Pune — from staff commutes to executive visits. Their centralized coordination has brought us unmatched efficiency and peace of mind.”',
    },
    {
        name: 'Ms. Tanya Joshi',
        designation: 'Senior HR Manager, ClariSys Pvt. Ltd., Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“With eTravo’s end-to-end solutions, we no longer juggle multiple vendors. Everything from cab scheduling to bus routes is managed seamlessly. A game-changer for corporate transport in Pune.”',
    },
];


















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "End-to-End Corporate Mobility Solutions Pune",
  "image": "https://www.etravo.in/images/keyword/end-to-end-corporate-mobility-pune.jpg",
  "description": "Comprehensive corporate mobility solutions in Pune by eTravo. End-to-end staff commute services including employee pickup and drop, integrated transport management, and customized monthly mobility plans for companies.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/end-to-end-corporate-mobility-solutions-pune"
  }
};








    return (
        <div>

<Helmet>
  <title>End-to-End Corporate Mobility Solutions Pune | Integrated Staff Transport & Commute Plans | eTravo</title>
  <meta 
    name="description" 
    content="eTravo offers end-to-end corporate mobility solutions in Pune, including managed staff transport, employee pickup and drop, corporate shuttle services, and monthly fleet plans tailored for businesses." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/111.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Endtoendcorporate;